<template>
    <div class="routerList swiper-container">
        <ul class="swiper-wrapper">
            <!-- @click="routeList(index)" -->
            <li
            v-for="(item,index) in allData[2].dataArr[4].list"
            :key="index"
            class="swiper-slide"
            @click="seeClick(index)"
            >
                <img :src="item.gpsImg">
                <div class="textBox">
                    <h2>{{ item.title }}</h2>
                    <p>{{ item.content_2 | addrs }}</p>
                    <div class="see">
                        查看详情
                        <img src="@/assets/img/map/seeDetails.png">
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let publicData = createNamespacedHelpers("publicData");
import Swiper from "swiper";
import 'swiper/css/swiper.css';
export default {
    data() { 
        return {

        }
    },
    mounted(){
        const _this = this;
        var swiper1 = new Swiper('.routerList', {
			slidesPerView: "auto",
            centeredSlides: true,
            initialSlide: _this.levelThreeIndex,
            on: {
                slideChangeTransitionStart(){
                    _this.routeList(this.activeIndex);
                },
            },
        });
        this.routeList(this.levelThreeIndex);
    },
    methods: {
        routeList(index){
            this.$emit("listSlideClick",index);
        },
        seeClick(index){
            this.setIndex({firstLevelIndex: 2,secondLevelIndex:4,levelThreeIndex: index});
            // this.setMapJumpListFlag(true);
            this.$router.push("/routerDetails");
        },
        ...publicData.mapMutations(["setIndex"])
    },
    computed: {
        ...publicData.mapState(["allData","getIntoMapFlag","levelThreeIndex","staticStateData"])
    },
    filters: {
        addrs(value){
            let arr = value.replace(/\n/g,"").split("<br />");
            let str = "";
            arr.forEach(item => {
                if(item.length > 10){
                    str += "——" + item.split("#")[0];
                }else{

                }
            });
            return str.replace(/——/,"")
        },
    },
}
</script>

<style lang="scss" scoped>
.routerList{
    width: 100%;
    height: 2.5rem;
    position: absolute;
    left: 0;
    // background: #0fc;
    bottom: 2.04rem;
    .swiper-wrapper{
        display: flex;
        align-items: center;
        li{
            width: 6.3rem;
            height: 2.3rem;
            background: #fff;
            box-shadow:0px .08rem .2rem 0rem rgba(50,50,50,0.2);
            border-radius: .1rem;
            overflow: hidden;
            padding: .26rem .48rem .24rem .18rem;
            margin-right: .5rem;
            &:first-of-type{
                margin-left: -.12rem;
            }
            display: flex;
            align-items: center;
            img{
                width: 1.8rem;
                height: 1.8rem;
                margin-right: .3rem;
            }
            .textBox{
                width: 3.8rem;
                h2{
                    font-size: .36rem;
                    color: #333;
                }
                p{
                    color: #999;
                    font-size: .22rem;
                    line-height: .32rem;
                    margin-top: .14rem;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
                .see{
                    display: flex;
                    align-items: center;
                    color: #388DFF;
                    font-size: .26rem;
                    margin-top: .28rem;
                    img{
                        width: .52rem;
                        height: .1rem;
                        margin-left: .06rem;
                    }
                }
            }
        }
    }
    
}
</style>